module.exports = __webpack_public_path__ + "static/media/musesbackground.208c9dfb.jpg";